import { render, staticRenderFns } from "./form-bggs.vue?vue&type=template&id=2cf8606e&scoped=true&"
import script from "./form-bggs.vue?vue&type=script&lang=js&"
export * from "./form-bggs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf8606e",
  null
  
)

export default component.exports